import { createContext } from 'react';

const AllPageNamesContext = createContext({
	allPageNames: null,
	setAllPageNames: () => {},
});

export default AllPageNamesContext;
